import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,Card,Typography,Breadcrumbs,Link
} from '@mui/material';
import Commonpage from '../../../Layout/Commonpage'; 
const workshopData = [
  {
    srNo: 1,
   // year: "2025-26",
    title: "Dr. PDKV, Akola- Annual Action Plan Workshop",
    venue: "Dr. PDKV Akola",
    date: "12 Feb 2026",
    //report: "/pdfs/annual-zonal-workshop-2025.pdf",
  },
  {
    srNo: 2,
    //year: "2024-25",
    title: "MPKV Rahuri- Annual Action Plan Workshop",
    venue: "MPKV Rahuri",
    date: "31 March 2026",
    //report: "/pdfs/annual-zonal-workshop-2024.pdf",
  },
  {
    srNo: 3,
   // year: "2023-24",
    title: "Dr. BSKKV,Dapoli- Annual Review & Action Plan Workshop",
    venue: "Dr. BSKKV, Dapoli",
    date: "02 April 2026",
    //report: "/pdfs/annual-zonal-workshop-2023.pdf",
  },
  {
    srNo: 4,
    //year: "2024-25",
    title: "VNMKV Parbhani- Annual Action Plan Workshop",
    venue: "VNMKV Parbhani",
    date: "05 May 2026",
    //report: "/pdfs/annual-zonal-workshop-2024.pdf",
  },
  {
    srNo: 5,
    //year: "2024-25",
    title: "Junagadh & Navasari Agricultural University- Annual Action Plan Workshop",
    venue: "Junagadh",
    date: "20 May 2026",
    //report: "/pdfs/annual-zonal-workshop-2024.pdf",
  },
];

const AnnualZonalWorkshop = () => {
  return (
       <Commonpage>
      <Box>
        <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 2, mt: 2 }}>
          <Table aria-label="land holding area table">
            <TableHead>
              <TableRow sx={{ backgroundColor: '#198754' }}>
                <TableCell sx={{ color: '#ffffff', fontWeight: 'bold' }}>Sr. No</TableCell>
                
                <TableCell sx={{ color: '#ffffff', fontWeight: 'bold' }}>Title</TableCell>
                <TableCell sx={{ color: '#ffffff', fontWeight: 'bold' }}>Venue</TableCell>
                 <TableCell sx={{ color: '#ffffff', fontWeight: 'bold' }}>Date</TableCell>
                
              </TableRow>
            </TableHead>
            <TableBody>
              {workshopData.map((data, index) => (
                <TableRow key={index} sx={{ '&:nth-of-type(odd)': { backgroundColor: '#f5f5f5' }, '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell component="th" scope="row" sx={{ color: '#333333' }}>
                    {index + 1}
                  </TableCell>
                  
                 
                 
                  <TableCell sx={{ color: '#333333' }}>{data.title}</TableCell>
                  <TableCell sx={{ color: '#333333' }}>{data.venue}</TableCell>
                  <TableCell sx={{ color: '#333333' }}>{data.date}</TableCell>
                  
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Commonpage>
  );
};

export default AnnualZonalWorkshop;